import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

interface MateriomLogoProps extends Omit<SvgIconProps, "viewBox"> {
  className?: string;
}

/**
 * Materiom AI Logo Component
 */
const MateriomLogo: React.FC<MateriomLogoProps> = ({ className, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 206.09 47.779"
      sx={{
        width: "auto",
        height: 36, // equivalent to h-9
        position: "absolute",
        top: 32, // equivalent to top-8
        left: 32, // equivalent to left-8
        color: "grey.500",
        zIndex: 10,
        ...props.sx,
      }}
      className={className}
    >
      <defs>
        <clipPath id="a">
          <rect
            width="206.09"
            height="47.779"
            fill="none"
            data-name="Rectangle 1254"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" fill="currentColor" data-name="Group 1708">
        <path
          transform="translate(0 -17.498)"
          d="M8.475,52.283l-1.209,2.1a1.956,1.956,0,0,1-1.686.973H3.159a1.957,1.957,0,0,1-1.69-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.776,3.776,0,0,0,0-3.781l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.776,3.776,0,0,0,0-3.781l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.96,1.96,0,0,1,1.69-.977H5.58a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947l-1.209,2.1a3.793,3.793,0,0,0,0,3.781l1.209,2.1A3.793,3.793,0,0,0,11.749,42.3H14.17a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H11.749a3.793,3.793,0,0,0-3.275,1.889"
          data-name="Path 2384"
        />
        <path
          transform="translate(-15.156 -8.749)"
          d="M24.011,18.729a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.959,1.959,0,0,1,1.686-.977h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1A3.793,3.793,0,0,0,35.5,18.671H37.92a1.955,1.955,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H35.5a3.793,3.793,0,0,0-3.275,1.889l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H26.905a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.793,3.793,0,0,0,0-3.781Z"
          data-name="Path 2385"
        />
        <path
          transform="translate(-15.156 -43.745)"
          d="M49.409,81.544a1.949,1.949,0,0,1,0,1.947L48.2,85.59a1.956,1.956,0,0,1-1.686.973H44.093a3.788,3.788,0,0,0-3.275,1.889l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H35.5a1.951,1.951,0,0,1-1.686-.973l-1.212-2.1a3.793,3.793,0,0,0-3.275-1.889H26.905a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.956,1.956,0,0,1,1.686-.973h2.421A3.8,3.8,0,0,0,32.6,76.583l1.212-2.1a1.951,1.951,0,0,1,1.686-.973H37.92a3.8,3.8,0,0,0,3.275-1.892l1.209-2.1a1.96,1.96,0,0,1,1.69-.977h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947l-1.209,2.1a3.793,3.793,0,0,0,0,3.781Z"
          data-name="Path 2386"
        />
        <path
          transform="translate(-30.306)"
          d="M47.751,5.019a1.949,1.949,0,0,1,0-1.947l1.212-2.1A1.955,1.955,0,0,1,50.649,0H53.07a1.955,1.955,0,0,1,1.686.977l1.212,2.1a3.788,3.788,0,0,0,3.275,1.889h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947l-1.209,2.1a1.956,1.956,0,0,1-1.686.973H59.243a1.957,1.957,0,0,1-1.69-.973l-1.209-2.1A3.793,3.793,0,0,0,53.07,8.091H50.649a1.951,1.951,0,0,1-1.686-.973Z"
          data-name="Path 2387"
        />
        <path
          transform="translate(-30.306 -26.247)"
          d="M71.94,53.209a3.793,3.793,0,0,0,0,3.781l1.212,2.1a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H67.833a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.793,3.793,0,0,0,0-3.781l-1.209-2.1a3.8,3.8,0,0,0-3.275-1.889H59.243a3.788,3.788,0,0,0-3.275,1.889l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H50.649a1.951,1.951,0,0,1-1.686-.973l-1.212-2.1a1.949,1.949,0,0,1,0-1.947l1.212-2.1a1.955,1.955,0,0,1,1.686-.977H53.07A3.793,3.793,0,0,0,56.345,44.2l1.209-2.1a1.96,1.96,0,0,1,1.69-.977h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a3.793,3.793,0,0,0,3.275,1.889h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947Z"
          data-name="Path 2388"
        />
        <path
          transform="translate(-60.618 -17.498)"
          d="M95.251,30.492l1.209-2.1a1.959,1.959,0,0,1,1.686-.977h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H98.145a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947"
          data-name="Path 2389"
        />
        <path
          transform="translate(-15.156 -8.749)"
          d="M40.819,23.69l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H35.5a3.793,3.793,0,0,0-3.275,1.889l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H26.905a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.793,3.793,0,0,0,0-3.781l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.959,1.959,0,0,1,1.686-.977h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1A3.793,3.793,0,0,0,35.5,18.671H37.92a1.955,1.955,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947"
          data-name="Path 2390"
        />
        <path
          transform="translate(0 -17.498)"
          d="M17.069,47.322l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H11.749a3.793,3.793,0,0,0-3.275,1.889l-1.209,2.1a1.956,1.956,0,0,1-1.686.973H3.159a1.957,1.957,0,0,1-1.69-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.776,3.776,0,0,0,0-3.781l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.776,3.776,0,0,0,0-3.781l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.96,1.96,0,0,1,1.69-.977H5.58a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947l-1.209,2.1a3.793,3.793,0,0,0,0,3.781l1.209,2.1A3.793,3.793,0,0,0,11.749,42.3H14.17a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947"
          data-name="Path 2391"
        />
        <path
          transform="translate(-15.156 -43.745)"
          d="M49.409,81.544a1.949,1.949,0,0,1,0,1.947L48.2,85.59a1.956,1.956,0,0,1-1.686.973H44.093a3.788,3.788,0,0,0-3.275,1.889l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H35.5a1.951,1.951,0,0,1-1.686-.973l-1.212-2.1a3.793,3.793,0,0,0-3.275-1.889H26.905a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.956,1.956,0,0,1,1.686-.973h2.421A3.8,3.8,0,0,0,32.6,76.583l1.212-2.1a1.951,1.951,0,0,1,1.686-.973H37.92a3.8,3.8,0,0,0,3.275-1.892l1.209-2.1a1.96,1.96,0,0,1,1.69-.977h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947l-1.209,2.1a3.793,3.793,0,0,0,0,3.781Z"
          data-name="Path 2392"
        />
        <path
          transform="translate(-30.306)"
          d="M64.559,9.98l-1.209,2.1a1.956,1.956,0,0,1-1.686.973H59.243a1.957,1.957,0,0,1-1.69-.973l-1.209-2.1A3.793,3.793,0,0,0,53.07,8.091H50.649a1.951,1.951,0,0,1-1.686-.973l-1.212-2.1a1.949,1.949,0,0,1,0-1.947l1.212-2.1A1.955,1.955,0,0,1,50.649,0H53.07a1.955,1.955,0,0,1,1.686.977l1.212,2.1a3.788,3.788,0,0,0,3.275,1.889h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a1.949,1.949,0,0,1,0,1.947"
          data-name="Path 2393"
        />
        <path
          transform="translate(-30.306 -26.247)"
          d="M73.153,59.085a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H67.833a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a3.793,3.793,0,0,0,0-3.781l-1.209-2.1a3.8,3.8,0,0,0-3.275-1.889H59.243a3.788,3.788,0,0,0-3.275,1.889l-1.212,2.1a1.951,1.951,0,0,1-1.686.973H50.649a1.951,1.951,0,0,1-1.686-.973l-1.212-2.1a1.949,1.949,0,0,1,0-1.947l1.212-2.1a1.955,1.955,0,0,1,1.686-.977H53.07A3.793,3.793,0,0,0,56.345,44.2l1.209-2.1a1.96,1.96,0,0,1,1.69-.977h2.421a1.959,1.959,0,0,1,1.686.977l1.209,2.1a3.793,3.793,0,0,0,3.275,1.889h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947l-1.212,2.1a3.793,3.793,0,0,0,0,3.781Z"
          data-name="Path 2394"
        />
        <path
          transform="translate(-60.618 -17.498)"
          d="M103.465,32.439l-1.212,2.1a1.947,1.947,0,0,1-1.686.973H98.145a1.956,1.956,0,0,1-1.686-.973l-1.209-2.1a1.949,1.949,0,0,1,0-1.947l1.209-2.1a1.959,1.959,0,0,1,1.686-.977h2.421a1.95,1.95,0,0,1,1.686.977l1.212,2.1a1.949,1.949,0,0,1,0,1.947"
          data-name="Path 2395"
        />
        <path
          transform="translate(-90.4 -25.526)"
          d="M161.743,40a6.41,6.41,0,0,0-5.974,3.38A5.58,5.58,0,0,0,150.424,40,6.162,6.162,0,0,0,145,42.895V40.521H141.66V58.375h3.456V47.61c0-2.67,1.668-4.527,4.158-4.527,2.67,0,3.785,1.78,3.785,4.082v11.21h3.488v-10.8c0-2.562,1.672-4.491,4.122-4.491,2.634,0,3.785,1.744,3.785,4.082v11.21h3.452V46.792c0-4.675-3.043-6.792-6.162-6.792"
          data-name="Path 2396"
        />
        <path
          transform="translate(-144.54 -25.462)"
          d="M241.611,55.38V46.431c0-3.488-2.081-6.531-7.425-6.531-3.861,0-6.944,2.374-7.313,5.79l3.34.782a3.788,3.788,0,0,1,4.046-3.6c2.71,0,3.861,1.447,3.861,3.192,0,.63-.3,1.187-1.371,1.335l-4.827.706c-3.079.445-5.421,2.229-5.421,5.421,0,2.819,2.341,5.345,5.978,5.345a6.507,6.507,0,0,0,5.753-2.971,13.283,13.283,0,0,0,.185,2.414h3.416a17.04,17.04,0,0,1-.221-2.931m-3.492-4.715c0,3.9-2.3,5.272-5.16,5.272a2.709,2.709,0,0,1-2.895-2.6,2.668,2.668,0,0,1,2.6-2.674l5.457-.818Z"
          data-name="Path 2397"
        />
        <path
          transform="translate(-176.82 -16.49)"
          d="M287.845,34.64V31.485h-3.861V25.84h-3.2v2.9a2.5,2.5,0,0,1-2.746,2.746h-.963V34.64h3.412v9.8c0,3.231,1.932,5.084,4.975,5.084a7.642,7.642,0,0,0,2.377-.333V46.22a6.948,6.948,0,0,1-1.375.148c-1.82,0-2.486-.814-2.486-2.45V34.64Z"
          data-name="Path 2398"
        />
        <path
          transform="translate(-201.11 -25.462)"
          d="m332.25 49.254c0-5.569-3.083-9.354-8.576-9.354-4.491 0-8.536 3.825-8.536 9.43 0 6.05 4.194 9.538 8.981 9.538a8.093 8.093 0 0 0 8.019-5.641l-3.007-1.042a4.869 4.869 0 0 1-5.012 3.6 5.3 5.3 0 0 1-5.381-5.421h13.436a7.451 7.451 0 0 0 0.076-1.115m-13.4-1.708a4.805 4.805 0 0 1 4.863-4.567 4.5 4.5 0 0 1 4.9 4.567z"
          data-name="Path 2399"
        />
        <path
          transform="translate(-239.14 -25.922)"
          d="M383.5,40.62a5.587,5.587,0,0,0-5.345,3.412V40.917H374.74V58.771h3.488V49.826c0-3.937,1.968-5.493,4.9-5.493a11.177,11.177,0,0,1,1.523.109V40.729a6.774,6.774,0,0,0-1.151-.109"
          data-name="Path 2400"
        />
        <path
          transform="translate(-261.79 -10.076)"
          d="m411.01 42.925h3.456v-17.853h-3.456zm1.708-27.135a2.506 2.506 0 1 0 2.526 2.526 2.5 2.5 0 0 0-2.526-2.526"
          data-name="Path 2401"
        />
        <path
          transform="translate(-277.1 -25.462)"
          d="m443.36 39.9c-5.345 0-9.133 4.046-9.133 9.466 0 5.457 3.789 9.5 9.133 9.5s9.133-4.046 9.133-9.5c0-5.421-3.789-9.466-9.133-9.466m0 15.849c-2.971 0-5.569-2.225-5.569-6.383 0-4.122 2.6-6.347 5.569-6.347s5.569 2.225 5.569 6.347c0 4.158-2.6 6.383-5.569 6.383"
          data-name="Path 2402"
        />
        <path
          transform="translate(-317.17 -25.526)"
          d="M517.1,40a6.412,6.412,0,0,0-5.978,3.38A5.58,5.58,0,0,0,505.78,40a6.162,6.162,0,0,0-5.421,2.895V40.521h-3.34V58.375h3.452V47.61c0-2.67,1.668-4.527,4.158-4.527,2.67,0,3.785,1.78,3.785,4.082v11.21H511.9v-10.8c0-2.562,1.672-4.491,4.121-4.491,2.634,0,3.785,1.744,3.785,4.082v11.21h3.452V46.792c0-4.675-3.043-6.792-6.159-6.792"
          data-name="Path 2403"
        />
      </g>
    </SvgIcon>
  );
};

export default MateriomLogo;
